module.exports = __webpack_public_path__ + "r-v3/img/person.07cb31c8.svg";